import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { MainComponent } from '@components/main/main.component';
import { User } from '@models/user';
import { ErrorResponse } from '@models/error.response';
import swal from 'sweetalert2'
import { switchMap } from 'rxjs/operators';
import {AppConstant} from "@constants/app.constant";
import { AuthService } from '@app/services/auth.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

    @ViewChild('loginForm', { static: false }) loginForm: NgForm;
    @ViewChild('forgetPasswordForm', { static: false }) forgetPasswordForm: NgForm;

    model: User = new User();
    errorCode: string;
    loading: boolean = false;
    isDocumentReady: boolean = false;
    forgotPasswordMode: boolean = false;
    companyName: String;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private translate: TranslateService,public appConstant: AppConstant,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.route.params
        .pipe(
            switchMap((params: Params) => {
                this.isDocumentReady = false;
                return of(params);
            })
        )
        .subscribe(() => {
            this.isDocumentReady = true;
        });
        
        if (this.authService.isLoggedIn()) {
            this.router.navigate(['/home']);
            return;
        }

        this.mainComponent.disableMenu();
        this.mainComponent.hideMenuCollapseButton();
        this.mainComponent.setContentBgWallpaper();
    }

    ngOnDestroy(): void {
        this.mainComponent.enableMenu();
        this.mainComponent.showMenuCollapseButton();
        this.mainComponent.setContentBgGray();
    }


    login(): void {
        let instance = this;

        for (let key of Object.keys(this.loginForm.controls)) {
            this.loginForm.controls[key].markAsDirty();
        }

        if (this.loginForm.valid) {
            this.loading = true;
            this.loginForm.control.disable();

            this.authService.authenticate(this.model.username, this.model.userPassword).subscribe(
                () => {
                    this.loading = false;
                    this.loginForm.control.enable();
                    this.router.navigate(['/home']);
                    
                },
                (error: ErrorResponse) => {
                    this.loading = false;
                    this.loginForm.control.enable();
                    this.errorCode = error.errors[0].errorCode;
                });
        }

    }

    forgetPassword(){
        let instance = this;
  
        for (let key of Object.keys(this.forgetPasswordForm.controls)) {
          this.forgetPasswordForm.controls[key].markAsDirty();
        }
  
        if(this.forgetPasswordForm.valid){
          this.loading = true;
          this.forgetPasswordForm.control.disable();
          this.authService.forgetPassword(this.model.userEmail).subscribe(res=>{
            if(res){
              this.translate.get('RESET_PASSWORD_SUCCESS')
              .subscribe(tres => {
                swal.fire({
                  type: 'success',
                  title: tres,
                });
                this.loading = false;
                this.forgotPasswordMode = false;
              });
            }
          },
          error => {
            this.translate.get('RESET_PASSWORD_FAIL')
            .subscribe(tres => {
              swal.fire({
                type: 'error',
                title: tres,
              });
              this.forgetPasswordForm.control.enable();
              this.loading = false;
            });
          })
        }
      }
}
